<template>
    <div class="login-container">
        <div class="main-box">
            <div class="logo-box">
                <div class="img-box">
                    <img src="https://cdn.bigbays.cn/pc/home/wanchao-logo2x.png" alt="">
                </div>
                <span>时事、财经、生活、部落</span>
            </div>
            <div class="login-btn" @click="goLogin()" v-if="isWx">登录</div>
            <div class="login-btn" @click="goDownload()" v-else>下载APP</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Login',
    data() {
        return {
            isWx: false
        }
    },
    created() {
        this.getWxFlag();
    },
    methods: {
        /**
         * @function getWxFlag 判断是否在微信端打开
         */
        getWxFlag() {
            var ua = navigator.userAgent.toLowerCase();
            this.isWx = ua.indexOf('micromessenger') != -1;
            window.sessionStorage.setItem('isweixin', JSON.stringify({iswx: this.isWx}));
        },
        goLogin() {
            window.location.href = "https://api.bigbays.cn/api/user/userinfo?type=2";
        },
        goDownload() {

        }
    }
}
</script>
<style lang="scss" scoped>
@import './Login.scss';
</style>


// WEBPACK FOOTER //
// src/components/mobile/common/login/Login.vue